var _rect, _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiKeyTakeaways(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.333,
    y: 0.667,
    width: 12,
    height: 13.333,
    rx: 1,
    fill: "#A8FFF8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 2.333,
    fill: "#CBFF88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 2.333,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M11.667 10.667h12v6.667h-12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.667 6.312c0-.149.122-.27.272-.27h5.455c.15 0 .273.121.273.27 0 .149-.123.27-.273.27h-5.455a.271.271 0 01-.272-.27zM21.496 2.079a.267.267 0 010 .381l-5.102 5.042-2.647-2.616a.267.267 0 010-.382.275.275 0 01.385 0l2.262 2.235 4.716-4.66a.275.275 0 01.386 0zM16.94 10.085c0-.149.121-.27.272-.27h8.182c.15 0 .273.121.273.27 0 .149-.123.27-.273.27h-8.182a.271.271 0 01-.273-.27zM16.94 14.397c0-.149.121-.27.272-.27h8.182c.15 0 .273.121.273.27 0 .149-.123.27-.273.27h-8.182a.271.271 0 01-.273-.27zM13.667 10.085c0-.149.122-.27.272-.27h1.637c.15 0 .272.121.272.27 0 .149-.122.27-.272.27h-1.637a.271.271 0 01-.272-.27zM13.667 14.397c0-.149.122-.27.272-.27h1.637c.15 0 .272.121.272.27 0 .149-.122.27-.272.27h-1.637a.271.271 0 01-.272-.27z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-key-takeaways-8558e10b03839e25dc8656df35f75315.svg";
export { SvgAiKeyTakeaways as ReactComponent };